var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pc-container-custom-video-slider"},[(_vm.slides.length > 0)?_c('slider-video',{attrs:{"slider-title":_vm.title,"route":_vm.route,"slidess":_vm.slides,"showSeeMore":_vm.showMore}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }